import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboIndex`, method: 'GET', body: null, token: token})
}